import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const store = {
  namespaced: true,

  state: {
    page: 0,
    brushColor: '#ff0000',
    brushWidth: 5,
    showBackgroundImage: true,
    mode: 'pencil',
    scale: 1,
    maxScale: 2,
    minScale: 0.8,
    // id, name, url, thumbnailUrl
    boards: []
  },
  mutations,
  actions,
  getters
};

export default store;
